import React from "react";
import { Reveal, Section, Container, EyebrowLarge } from "./Shared";

const problems = [
    {
        title: "Bridging the Market Gap",
        description:
            "IVANI connects organizations instantly with the right partners, eliminating delays and mismatches that stall growth.",
    },
    {
        title: "Streamlining Complex Vendor Networks",
        description:
            "IVANI simplifies multi-vendor management, reducing inefficiency, miscommunication, and fragmented results.",
    },
    {
        title: "Closing the Talent Readiness Gap",
        description:
            "We prepare future leaders with practical skills and confidence, equipping them to meet real industry demands beyond traditional academics.",
    },
    {
        title: "Navigating Change & Complexity",
        description:
            "IVANI handholds clients through every transition, transformation, and execution phase with expert advice and strategic support.",
    },
];

export default function ProblemsWeSolve() {
    return (
        <Section id="problems" className="relative font-body py-24 md:py-32">
            {/* Background Ambience */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full blur-[120px] pointer-events-none opacity-[0.1]" style={{ background: 'var(--ivani-color)' }} />

            <Container>
                <div className="text-center mb-16">
                    <EyebrowLarge>PROBLEMS WE SOLVE</EyebrowLarge>
                    <p className="text-zinc-400 text-lg max-w-2xl mx-auto font-light">
                        We address the critical friction points that slow down potential.
                    </p>


                </div>

                <div className="grid gap-6 md:grid-cols-2">
                    {problems.map((t, i) => (
                        <Reveal key={i} className="h-full">
                            <div className="group h-full glass-card p-8 md:p-10 rounded-[32px] border border-white/10 hover:border-white/20 transition-all duration-500 hover:-translate-y-1 bg-white/5 relative overflow-hidden">
                                <div className="absolute top-0 right-0 p-8 opacity-20 group-hover:opacity-100 transition-opacity duration-500">
                                    <span className="text-6xl font-heading font-bold text-white/5 group-hover:text-white/10 transition-colors">0{i + 1}</span>
                                </div>

                                <div className="relative z-10">
                                    <h3 className="font-heading text-2xl font-bold text-white mb-4 group-hover:text-white transition-colors">{t.title}</h3>
                                    <p className="text-zinc-400  text-base md:text-lg leading-relaxed font-light group-hover:text-zinc-300 transition-colors">{t.description}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </Container>
        </Section>
    );
}
